import { useRef, useState } from 'react';
import { useOutletContext } from 'react-router-dom';

/**
 * Bundles the page-level Stepper state: practice resolution and the various
 * UI-toggle flags. Throws if a practice cannot be resolved from props or
 * route context.
 */
export default function useStepperPageState({
  practiceData,
  isAuthenticated,
  requirePractice = true
}) {
  const outletContext = useOutletContext() || {};
  const { practice: practiceContext } = outletContext;
  const practice = practiceData ?? practiceContext;

  if (requirePractice && !practice) {
    throw new Error(
      'No practice found, please provide `practiceData` as prop or ensure Stepper is wrapped in a Route with practice context.'
    );
  }

  const [showIntro, setShowIntro] = useState(isAuthenticated);
  const [showTasksIntro, setShowTasksIntro] = useState(isAuthenticated);
  const [navigateToCode, setNavigateToCode] = useState(null);
  const [headerButtonProps, setHeaderButtonProps] = useState(null);
  const [headerInfoTooltip, setHeaderInfoTooltip] = useState(null);
  const mainContentRef = useRef(null);

  return {
    practice,
    mainContentRef,
    showIntro,
    setShowIntro,
    showTasksIntro,
    setShowTasksIntro,
    navigateToCode,
    setNavigateToCode,
    headerButtonProps,
    setHeaderButtonProps,
    headerInfoTooltip,
    setHeaderInfoTooltip
  };
}
